export function getOptimizedImageUrl(url: string | undefined, size = 'full'): string | undefined {
  if (!url) return url

  let width = 800 // default for 'full' or 'none'
  switch (size) {
    case 'xs':
      width = 100
      break
    case 'sm':
      width = 150
      break
    case 'md':
      width = 200
      break
    case 'lg':
      width = 300
      break
    case 'xl':
      width = 500
      break
    case 'full':
      width = 800
      break
    case 'none':
      width = 800
      break
  }

  if (url.includes('res.cloudinary.com')) {
    // If it already has some format/quality transformations, update the width instead of bailing out
    if (url.includes('/upload/f_auto') || url.includes('/upload/c_fit')) {
      return url.replace(/w_\d+/, `w_${width}`)
    }

    const uploadIndex = url.indexOf('/upload/')
    if (uploadIndex !== -1) {
      const baseUrl = url.substring(0, uploadIndex + 8)
      const remainder = url.substring(uploadIndex + 8)
      return `${baseUrl}f_auto,q_auto,w_${width},c_fit/${remainder}`
    }
  }

  if (url.includes('images.unsplash.com')) {
    try {
      const urlObj = new URL(url)
      urlObj.searchParams.set('auto', 'format')
      urlObj.searchParams.set('w', width.toString())
      urlObj.searchParams.set('q', '75')
      return urlObj.toString()
    } catch (_e) {
      return url
    }
  }

  return url
}
